import * as React from 'react';

interface AccordionIconProps {
    isExpanded: boolean;
}

const AccordionIcon: React.FC<AccordionIconProps> = ({ isExpanded }) => {
    if (isExpanded) {
        return (
            <svg
                width="16"
                height="21"
                viewBox="0 0 16 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="accordion-icon"
            >
                <g clipPath="url(#clip0_7014_38390)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M0 13C0 12.5858 0.335786 12.25 0.75 12.25L15.25 12.25C15.6642 12.25 16 12.5858 16 13C16 13.4142 15.6642 13.75 15.25 13.75L0.75 13.75C0.335786 13.75 0 13.4142 0 13Z"
                        fill="#01336B"
                    />
                </g>
                <defs>
                    <clipPath id="clip0_7014_38390">
                        <rect width="16" height="21" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        );
    }

    return (
        <svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg" className="accordion-icon">
            <g clipPath="url(#clip0_7014_38381)">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8 5C8.41422 5 8.75 5.33579 8.75 5.75V12.25L15.25 12.25C15.6642 12.25 16 12.5858 16 13C16 13.4142 15.6642 13.75 15.25 13.75H8.75V20.25C8.75 20.6642 8.41422 21 8 21C7.58579 21 7.25 20.6642 7.25 20.25L7.25 13.75H0.75C0.335786 13.75 0 13.4142 0 13C0 12.5858 0.335786 12.25 0.75 12.25H7.25L7.25 5.75C7.25 5.33579 7.58579 5 8 5Z"
                    fill="#01336B"
                />
            </g>
            <defs>
                <clipPath id="clip0_7014_38381">
                    <rect width="16" height="21" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default AccordionIcon;
